import React, { useContext, useEffect, useState } from "react";
import Routes from "routes";
import "./App.scss";
import { dispatch } from "redux/store";
import { setUser } from "redux/slices/user";
import { checkUserAuthStatus } from "./utils/tools";

function App() {
  const [userData, setUserData] = useState(null);
  const getUserData = async () => {
    try {
      if (!!client) {
        let userInfo = await client.get("currentUser");
        let timeZone = await client.get("currentAccount.timeZone");

        let appContextResponse = {};
        let appMetadataResponse = {};
        appContextResponse = await client.context();
        appMetadataResponse = await client.metadata();
        let appId = appMetadataResponse?.appId;
        let installationId = appMetadataResponse?.installationId;
        let subdomain = appContextResponse?.account.subdomain;

        //Call backend api to check the user authorisation status
        let authStatusQueryData = {
          subdomain,
          appid: appId,
          installationid: installationId,
        };

        let authStatusDetailData = await checkUserAuthStatus(authStatusQueryData);
        let app_user_uuid = authStatusDetailData?.uuid;

        if (!!userInfo && !!userInfo.currentUser) {
          let userData = {
            email: userInfo.currentUser.email,
            id: userInfo.currentUser.id,
            name: userInfo.currentUser.name,
            role: userInfo.currentUser.role,
            app_user_uuid: app_user_uuid,
            app_user_auth_detail: !!authStatusDetailData ? authStatusDetailData : null,
            zendesk_subdomain: subdomain,
            time_zone: timeZone["currentAccount.timeZone"].ianaName,
          };
          console.log({ reduxUserData: userData });
          setUserData(userData);
          dispatch(setUser(userData));
        }
        console.log("App useEffect userInfo");
      }
    } catch (e) {
      console.log(e);
    }
  };
  // getUserData();

  useEffect(() => {
    getUserData();
  }, []);
  return <>{userData != null && <Routes />}</>;
}

export default App;
